
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import { AxiosResponse } from 'axios'
import { magnoliaServiceAPI } from '@/store/api-instance'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'
import localStorageCache from '@/utils/localStorageCache'
import 'vue3-carousel/dist/carousel.css'
import CacheKeys from '@/utils/CacheKeys'
import { RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'

const BANNER_ROTATION = 8000

interface IBannersContent {
id: string
locationId: string
image: {
  link?: string
  [key: string]: any
}
[key: string]: any
url: string
}

interface IBannersResponse {
limit: number
offset: number
total: number
results: Array<IBannersContent>
}
export default defineComponent({
  name: 'BannersComponent',

  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },

  props: {
    location: {
      type: String,
      default: ''
    }
  },

  mixins: [refreshAfterChangeLanguage, localStorageCache],

  data: () => {
    return {
      slides: null as Array<IBannersContent> | null,
      settings: {
        itemsToShow: 1,
        snapAlign: 'center'
      },
      rotation: BANNER_ROTATION
    }
  },

  computed: {
    isLoggedIn () {
      const token = sessionStorage.getItem('id_token')
      return this.$store.state.auth.user.isLoggedIn && !!token
    },

    pathInner (): string {
      return this.$route.name as string
    },

    customerType (): RolePermissionDetails | undefined {
      if (this.user && this.user?.permissionSchema?.length > 0) {
        return this.user?.permissionSchema[0]?.rpDetails?.find((item: RolePermissionDetails) => item.customerType)
      }
      return undefined
    },
    user () {
      return this.$store.state.auth.user
    },

    path (): string {
      if (this.pathInner === 'homepage') {
        if (this.isLoggedIn) {
          return this.pathInner + 'AfterLogin'
        } else {
          return this.pathInner + 'BeforeLogin'
        }
      }
      return this.pathInner
    }
  },

  watch: {
    path () {
      this.refresh()
    },
    isLoggedIn () {
      this.refresh()
    }
  },

  created () {
    this.refresh()
  },

  methods: {
    refresh () {
      this.getStaticData()
    },

    async getStaticData () {
      if (!this.path || this.path === 'products') return

      const locationName = this.location !== '' ? this.location : this.path
      if (!locationName) return

      try {
        let apiPath = '/publicbanners'
        let key = CacheKeys.CACHE_BANNER_PUBLIC

        if (this.isLoggedIn) {
          apiPath = '/banners'

          if (locationName === 'marketingMaterials') {
            key = CacheKeys.CACHE_BANNER_FILE
          } else {
            key = CacheKeys.CACHE_BANNER
          }
        }

        const cache = await this.getCache(key)

        if (cache?.length > 0) {
          this.slides = cache
            ?.filter((image: any) => image?.link !== null)
            .sort((a: any, b: any) => a.page - b.page)
        } else {
          const params = {
            locationId: locationName,
            ...(apiPath === '/banners' && {
              customertype: this.customerType?.customerType || localStorage.getItem('customertype'),
              uid: sessionStorage.getItem('uid')
            })
          }

          const response: AxiosResponse<IBannersResponse> =
        await magnoliaServiceAPI.get(apiPath, { params })

          const data = response.data.results
          this.slides = data?.filter(image => image?.link !== null)

          this.setCache(key, data)
        }
      } catch (error) {
        console.error(error)
      }
    },
    useStripHtml (html: string) {
      const regex = /(<([^>]+)>)/ig
      return html.replace(regex, '')
    }
  }
})
